module.exports = __webpack_public_path__ + "static/quoralimitex2-ba1543d8fbfece82b4b3a59ffcd49b6c.svg";